import api from "./api";
import merchantToken from "./merchant.token";
import ls from "./secure.ls";

const storage = ls.appLS();

const SERVICE_URL = "customer-service/customer";

export default {
  authToken() {
    return storage.get("auth-token");
  },
  customerDetails() {
    return storage.get("customer-details");
  },
  customerMobile() {
    return storage.get("customer-mobile");
  },
  customerEmail() {
    return storage.get("customer-email");
  },
  customerOtp() {
    return storage.get("customer-otp");
  },
  login(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}/login/mobile`,
        payload,
        {
          "X-Merchant-Token": merchantToken.merchantToken()
        }
      )
        .then(response => {
          storage.set("auth-token", response.token);
          storage.set("customer-details", response.customer);
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  register(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}/mp/register`,
        payload,
        {
          "X-Merchant-Token": merchantToken.merchantToken()
        }
      )
        .then(response => {
          storage.set("auth-token", response.token);
          storage.set("customer-details", response.customer);
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  setPin(payload) {
    const self = this;
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}/pin/set`,
        payload,
        {
          "X-Merchant-Token": merchantToken.merchantToken(),
          "Authorization": self.authToken()
        }
      )
        .then((response) => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  sendOtp(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}/otp`,
        payload,
        {
          "X-Merchant-Token": merchantToken.merchantToken()
        }
      )
        .then(response => {
          storage.set("customer-mobile", response.mobile_number);
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  verifyOtp(payload) {
    const origin = payload.origin;
    delete payload.origin;

    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}/otp/verify/${origin}/advance`,
        payload,
        {
          "X-Merchant-Token": merchantToken.merchantToken()
        }
      )
        .then(response => {
          storage.set("auth-token", response.token);
          storage.set("customer-details", response.customer);
          storage.set("customer-otp", response.otp);
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  resetMpin(payload) {
    const self = this;
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}/forgot-pin/mobile`,
        payload,
        {
          "X-Merchant-Token": merchantToken.merchantToken(),
          "X-Otp-Token": self.authToken()
        }
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  sendOtpEmail(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}/otp/email`,
        payload,
        {
          "X-Merchant-Token": merchantToken.merchantToken()
        }
      )
        .then(response => {
          storage.set("customer-email", response.email);
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  }
};
